import type { ReactNode } from 'react';
import type { DayType } from '../types';

export const startHourOptions = Array.from({ length: 24 }, (_, i) => {
  const value = (i + 5) % 24;
  return { value, label: `${String(value).padStart(2, '0')}:00` };
});

export const endHourOptions = Array.from({ length: 24 }, (_, i) => {
  const value = (i + 6) % 24;
  return { value, label: `${String((value - 1 + 24) % 24).padStart(2, '0')}:59` };
});

// Band label column, shared so band matrices line up with each other. Wide enough
// for the longest day-type label on one line, since that header cell does not wrap.
export const BAND_COLUMN_WIDTH = 120;

export const dayTypeLabels: Record<DayType, ReactNode> = {
  WD: 'Weekday (WD)',
  WE: 'Weekend (WE)',
  ALL: 'Common (WE/WD)',
};
